/* global Swiper */

import { popupOpen } from '../../js/components/popup_people';

popupOpen();

( () => {

	// Block Name
	const blockName = 'people-slider';

	// Environment
	const method =
		document.querySelector( 'body' ) === null ||
		document.querySelector( 'body' ).classList.contains( 'wp-admin' )
			? 'wp-admin'
			: 'front';

	/**
	 * Initialize Block
	 *
	 * @param  {node} block
	 *
	 * @return {node}
	 */
	const initializeBlock = ( block ) => {

		/////////////////////
		// BLOCK CODE HERE //
		/////////////////////

		const blockSwiper = block.querySelector( '.swiper' );

		const prevEl = block.querySelector( '.swiper-prev' );
		const nextEl = block.querySelector( '.swiper-next' );

		new Swiper( blockSwiper, {
			slidesPerView: 1.5,
			spaceBetween: 10,
			autoHeight: false,
			loop: false,
			slideClass: 'b-people-slider-item',
			breakpoints: {
				640: {
					slidesPerView: 1.5,
				},
				768: {
					slidesPerView: 2,
				},
				1024: {
					slidesPerView: 3,
				},
			},
			navigation: {
				prevEl: prevEl,
				nextEl: nextEl,
			},
		} );

		return block;

	};

	/**
	 * Get all blocks
	 *
	 * @return {void}
	 */
	const getBlocks = () => {

		const blocks = document.querySelectorAll( `.b-${ blockName }` );
		if ( blocks.length > 0 ) {

			blocks.forEach( ( block ) => {

				if ( block !== false && block !== null ) {

					initializeBlock( block );

				}

			} );

		}

	};

	/**
	 * Run on frontend
	 *
	 * @param  {string} method
	 *
	 * @return {void}
	 */
	if ( method === 'front' ) {

		document.addEventListener( 'DOMContentLoaded', getBlocks );

	}

	/**
	 * Run on backend
	 *
	 * @param  {string} method
	 *
	 * @return {void}
	 */
	if ( method === 'wp-admin' ) {

		window.addEventListener( 'load', () => {

			document.addEventListener( 'DOMContentLoaded', getBlocks );

			if ( window.acf ) {

				getBlocks();

				// Add update block action for ACF
				window.acf.addAction(
					`render_block_preview/type=${ blockName }`,
					initializeBlock
				);

			}

		} );

	}

} )();
